import _ from 'lodash';

export default (obj = {}) => _.compact(Object.keys(obj).map((key) => !_.isUndefined(obj[key]) ? key + '=' + obj[key] : '')).join('&');